import { createFileRoute } from "@tanstack/react-router";
import { DefaultCatchBoundary } from "~/components/default-catch-boundary";
import {
  normalizeAppSettingsSearch,
  type AppSettingsSearch,
} from "~/features/settings/settings-search";

export const Route = createFileRoute("/_app")({
  validateSearch: (raw): AppSettingsSearch =>
    normalizeAppSettingsSearch(raw as Record<string, unknown>),
  ssr: true,
  errorComponent: DefaultCatchBoundary,
  loader: ({ context, location }) => {
    if (import.meta.env.SSR) return;
    void import("~/features/app-shell/app-shell-route").then(
      ({ preloadAppShellSidebarData }) => {
        void preloadAppShellSidebarData({
          context,
          pathname: location.pathname,
        });
      },
    );
  },
});
